/**
 * #2186 (founder, 11 Oct 2026 — "old seat until re-publish") — the words for
 * a lead's changes to a roster members already have. Until the lead presses
 * Publish, members keep seeing the roster as it was published, so the lead's
 * page says plainly that changes are waiting and who still sees what.
 *
 * `count` is the roster read's `unpublished_count`: the seats that differ
 * between what members see and what Publish would leave them seeing (a delete
 * counts 1, a swap 2, an edit put back 0).
 */

function changes(count: number): string {
  return `${count} ${count === 1 ? "change" : "changes"}`;
}

/** The toolbar's status mark: *"2 changes waiting to be published"*. */
export function waitingChangesMark(count: number): string {
  return `${changes(count)} waiting to be published`;
}

/** The header line and the next-step row:
 *  *"2 changes waiting to be published · members still see the published roster"*. */
export function waitingChangesLine(count: number): string {
  return `${waitingChangesMark(count)} · members still see the published roster`;
}

/** A changed cell's hover. */
export const WAITING_CELL_HINT = "Not published yet · members still see the published seat";
